const levels = [
  {
    level: "1",
    firebaseId: "qYLRPOKKHyLcrX3dxEpt",
    name: "variable-one",
    title: "Variable",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Text">
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                </category>
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
              </xml>`
  },
  {
    level: "2",
    firebaseId: "tIvlHBFwoNeJf1zhy8ZN",
    name: "variable-two",
    title: "Variable 2",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Text">
                  <block type="text_print">
                    <value name="TEXT">
                    </value>
                  </block>
                </category>
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
              </xml>`,
    workspace: `<xml xmlns="https://developers.google.com/blockly/xml" id="workspaceBlocks" style="display: none">
                <variables>
                  <variable id="greeting">myGreetings</variable>
                </variables>
                <block type="variables_set" id="variable" x="37" y="37">
                  <field name="VAR" id="greeting">myGreetings</field>
                  <value name="VALUE">
                    <block type="text" id="-G=9wkV,xuIl=]bANM|_">
                      <field name="TEXT">Hi, how are you?</field>
                    </block>
                  </value>
                </block>
              </xml>`
  },
  {
    level: "3",
    name: "list-one",
    firebaseId: "agm6gfaJ0nK4jwcZRkb7",
    title: "List",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Main">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                  <block type="lists_getIndex">
                    <mutation statement="false" at="true"></mutation>
                    <field name="MODE">GET</field>
                    <field name="WHERE">FROM_START</field>
                    <value name="VALUE">
                    </value>
                  </block>
                  <block type="lists_setIndex">
                    <mutation at="true"></mutation>
                    <field name="MODE">SET</field>
                    <field name="WHERE">FROM_START</field>
                    <value name="LIST">
                    </value>
                  </block>
                </category>
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
              </xml>`,
    workspace: `<xml xmlns="https://developers.google.com/blockly/xml" id="workspaceBlocks" style="display: none">
                  <variables>
                    <variable id="va=av*Hf=UF#ydB~0@*">myFruits</variable>
                  </variables>
                  <block type="variables_set" id="0s@kP{-%eec8|M[n#ELN" x="13" y="13">
                    <field name="VAR" id="va=av*Hf=UF#ydB~0@*">myFruits</field>
                    <value name="VALUE">
                      <block type="lists_create_with" id="OOKIhRBs_.T1I+qd(p9K">
                        <mutation items="3"></mutation>
                        <value name="ADD0">
                          <block type="text" id="~98]gg/fEU-gA(hmJP%s">
                            <field name="TEXT">orange</field>
                          </block>
                        </value>
                        <value name="ADD1">
                          <block type="text" id="?.]bX}d2Qr[KW2JA?kND">
                            <field name="TEXT">watermelon</field>
                          </block>
                        </value>
                        <value name="ADD2">
                          <block type="text" id="eBzX)xOqRO-QguY)oQ*p">
                            <field name="TEXT">banana</field>
                          </block>
                        </value>
                      </block>
                    </value>
                  </block>
                </xml>`
  },
  {
    level: "4",
    firebaseId: "T0dgbdRgllAcMLgY55CP",
    title: "Operators",
    name: "operator-one",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Math">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                  <block type="math_arithmetic">
                    <field name="OP">ADD</field>
                  </block>
                </category>
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
              </xml>`
  },
  {
    level: "5",
    firebaseId: "hM5vZN4dJVRdZxR0Zas3",
    title: "Loops 1",
    name: "loop-one",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <block type="math_number">
                  <field name="NUM">0</field>
                </block>
                <block type="math_arithmetic">
                  <field name="OP">ADD</field>
                </block>
                <block type="variables_set">
                  <field name="VAR" id="JxSq(2NE*_Od//A5[zyH">myNumber</field>
                </block>
                <block type="variables_get">
                  <field name="VAR" id="+p;]vg=MqoI+82-#uYy;">myNumber</field>
                </block>
              </xml>`,
    workspace: `<xml xmlns="https://developers.google.com/blockly/xml" id="workspaceBlocks" style="display: none">
                  <variables>
                    <variable id="f@k_$dxlN7|b*S.Z?BX_">myNumber</variable>
                    <variable id="Wu)#_r0Oki#4z|08^++|">i</variable>
                  </variables>
                  <block type="variables_set" id="loop" x="38" y="38">
                    <field name="VAR" id="f@k_$dxlN7|b*S.Z?BX_">myNumber</field>
                    <value name="VALUE">
                      <block type="math_number" id="V6=riHjs3aT$su.s6NPm">
                        <field name="NUM">0</field>
                      </block>
                    </value>
                    <next>
                      <block type="controls_for" id="huvi3s6lOO(QHForzY%n">
                        <field name="VAR" id="Wu)#_r0Oki#4z|08^++|">i</field>
                        <value name="FROM">
                          <shadow type="math_number" id="fFTF{U;3,TK2C;LTCjey">
                            <field name="NUM">1</field>
                          </shadow>
                        </value>
                        <value name="TO">
                          <shadow type="math_number" id="[S@}vCQfCP}E-[;XX-iC">
                            <field name="NUM">10</field>
                          </shadow>
                        </value>
                        <value name="BY">
                          <shadow type="math_number" id="m/0D4Tc+40kT~:K.OXL]">
                            <field name="NUM">1</field>
                          </shadow>
                        </value>
                      </block>
                    </next>
                  </block>
                </xml>`
  },
  {
    level: "6",
    title: "Loops 2",
    firebaseId: "gnGApXatEzhCqJW0cmLg",
    name: "loop-two",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <block type="math_number">
                  <field name="NUM">0</field>
                </block>
                <block type="math_arithmetic">
                  <field name="OP">ADD</field>
                  <value name="A">
                  </value>
                  <value name="B">
                  </value>
                </block>
                <block type="variables_set">
                  <field name="VAR" id="t8*/WHZ_-Sq?t6Fqvk3Q">evenSum</field>
                </block>
                <block type="variables_get">
                  <field name="VAR" id="t8*/WHZ_-Sq?t6Fqvk3Q">evenSum</field>
                </block>
                <block type="variables_get">
                  <field name="VAR" id="xF.K_LI3I3UGr@~Cm!nT">i</field>
                </block>
              </xml>`,
    workspace: `<xml xmlns="https://developers.google.com/blockly/xml" id="workspaceBlocks" style="display: none">
                  <variables>
                    <variable id="AVp5lF~Fm,0E*GrD*IO%">evenSum</variable>
                    <variable id="f3[5coI:Nt1_VlVm49EC">i</variable>
                  </variables>
                  <block type="variables_set" id="9WmZy4W[xM-|.2Ms}/!7" x="13" y="13">
                    <field name="VAR" id="AVp5lF~Fm,0E*GrD*IO%">evenSum</field>
                    <value name="VALUE">
                      <block type="math_number" id=".W~dOJrnj/)yz:Za?2jx">
                        <field name="NUM">0</field>
                      </block>
                    </value>
                    <next>
                      <block type="controls_for" id="!GDnutShBMakz(nuH|Nd">
                        <field name="VAR" id="f3[5coI:Nt1_VlVm49EC">i</field>
                      </block>
                    </next>
                  </block>
                </xml>`
  },
  {
    level: "7",
    firebaseId: "SmNTAICfPjy5GglBUexG",
    title: "Conditionals 1",
    name: "conditional-one",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
                <category name="Logic" colour="#5b80a5">
                  <block type="controls_if"></block>
                  <block type="logic_compare">
                    <field name="OP">EQ</field>
                  </block>
                  <block type="logic_boolean">
                    <field name="BOOL">TRUE</field>
                  </block>
                </category>
                <category name="Text" colour="#5ba58c">
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                  <block type="text_print"></block>
                </category>
                <category name="Math" colour="#5b67a5">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                </category>
                </xml>`
  },
  {
    level: "8",
    firebaseId: "YmMWgCFtQxU0Hoa9dira",
    title: "Conditionals 2",
    name: "conditional-two",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <block type="logic_boolean">
                  <field name="BOOL">TRUE</field>
                </block>
                <block type="logic_compare">
                  <field name="OP">EQ</field>
                </block>
                <block type="logic_operation">
                  <field name="OP">AND</field>
                </block>
                <block type="math_number">
                  <field name="NUM">0</field>
                </block>
                <block type="math_modulo"></block>
                <block type="variables_get">
                  <field name="VAR" id="w9$b*3L_AK_l(g/I?/Zi">number</field>
                </block>
                <block type="variables_set">
                  <field name="VAR" id="{h{*J;phVL/k=S{hP8ol">isOddAndGreaterThanFifty</field>
                </block>
              </xml>`,
    workspace: `<xml xmlns="https://developers.google.com/blockly/xml" id="workspaceBlocks" style="display: none">
                  <variables>
                    <variable id="0Y.6xLhFMKf~:t}7W]gL">number</variable>
                    <variable id="M6t_c%,~Xwyxb}qS_wzk">isOddAndGreaterThanFifty</variable>
                  </variables>
                  <block type="procedures_defreturn" id="/uNCQ6MS;HlU|[j.8EW+" x="20" y="20">
                    <mutation>
                      <arg name="number" varid="0Y.6xLhFMKf~:t}7W]gL"></arg>
                    </mutation>
                    <field name="NAME">checkNumber</field>
                    <comment pinned="false" h="80" w="160">Describe this function...</comment>
                    <statement name="STACK">
                      <block type="variables_set" id="Lij?$v{xAzg$SEjI?C,i">
                        <field name="VAR" id="M6t_c%,~Xwyxb}qS_wzk">isOddAndGreaterThanFifty</field>
                        <value name="VALUE">
                          <block type="logic_null" id="Z{$Y.4/vz:xERnM[$qV*"></block>
                        </value>
                        <next>
                          <block type="controls_if" id="(Hb+IWZT$.on?xgo|~DZ"></block>
                        </next>
                      </block>
                    </statement>
                    <value name="RETURN">
                      <block type="variables_get" id="~q!Ms}hPcxM$EKV{yEi8">
                        <field name="VAR" id="M6t_c%,~Xwyxb}qS_wzk">isOddAndGreaterThanFifty</field>
                      </block>
                    </value>
                  </block>
                </xml>`
  },
  {
    level: "9",
    firebaseId: "6OqMl67TSJucsIcazeRG",
    title: "Function 1",
    name: "function-one",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Functions" colour="#995ba5" custom="PROCEDURE"></category>
                <category name="Text" colour="#5ba58c">
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                  <block type="text_print"></block>
                </category>
              </xml>`
  },
  {
    level: "10",
    firebaseId: "5mK13tLVp2wKxus6xhJF",
    title: "Function 2",
    name: "function-two",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Functions" colour="#995ba5" custom="PROCEDURE"></category>
                <category name="Text" colour="#5ba58c">
                  <block type="text">
                    <field name="TEXT"></field>
                  </block>
                  <block type="text_join">
                    <mutation items="2"></mutation>
                  </block>
                  <block type="text_print"></block>
                </category>
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
              </xml>`
  },
  {
    level: "11",
    firebaseId: "ogF2yjZuKqXe5lfJvPvr",
    title: "Function 3",
    name: "function-three",
    toolbox: `<xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
                <category name="Functions" colour="#995ba5" custom="PROCEDURE"></category>
                <category name="Math" colour="#125588">
                  <block type="math_number">
                    <field name="NUM">0</field>
                  </block>
                  <block type="math_arithmetic">
                    <field name="OP">ADD</field>
                  </block>
                </category>
                <category name="Variables" colour="#a55b80" custom="VARIABLE"></category>
              </xml>`
  }
];

class LevelRepository {
  getLevels() {
    return levels;
  }

  getLevel(level) {
    let levelNumber = parseInt(level);
    return levels[levelNumber - 1];
  }
}

export default new LevelRepository();
